import { useLocation } from "../hooks/useLocation.js";
import "../constants.js";
import { useRPCServerEventHandler } from "../../../hooks/useRPCServerEventHandler/index.js";
import React, { useCallback, useContext } from "react";
import { Loading } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Locations/contexts/LocationContext.tsx
var LocationContext = React.createContext(void 0);
var LocationContextProvider = ({ children, LoadingComponent, locationId }) => {
	const { data, loading, refresh } = useLocation({ locationId });
	useRPCServerEventHandler("LocationUpdated", (evt, data) => {
		if (locationId === data.locationId || data.locationId === "loc-") refresh();
	});
	const isModuleActive = useCallback((moduleName) => {
		return !!data?.location?.settings?.modules?.[moduleName];
	}, [data]);
	if (!data?.location) return LoadingComponent ? /* @__PURE__ */ jsx(LoadingComponent, {}) : /* @__PURE__ */ jsx(Loading, {
		message: "Loading Location",
		overlay: true
	});
	return /* @__PURE__ */ jsx(LocationContext.Provider, {
		value: {
			isModuleActive,
			loading,
			location: data?.location,
			locationId,
			refresh
		},
		children
	});
};
function useLocationContext(ctxRequired) {
	const ctx = useContext(LocationContext);
	if (ctxRequired && !ctx) throw new Error("context is required for useLocationContext()");
	return ctx;
}
//#endregion
export { LocationContext, LocationContextProvider, useLocationContext };

//# sourceMappingURL=LocationContext.js.map